class Slider {
  constructor(options) {
    this.sections = document.querySelectorAll(options.section);
    this.navigation = document.querySelector(options.dots);

    this.navigation.addEventListener('click', this.scrollToSection.bind(this));
    window.addEventListener('scroll', this.setDotStatus.bind(this));
  }

  removeDotStyles() {
    const dots = this.navigation;
    const isActive = dots.querySelector('.is-active');

    if (isActive != null) {
      isActive.classList.remove('is-active');
    }
  }

  setDotStatus() {
    const scrollPosition = window.scrollY;
    const dots = Array.from(this.navigation.children);

    this.sections.forEach((section, index) => {
      const halfWindow = window.innerHeight / 2;
      const sectionTop = section.offsetTop;

      if (
        scrollPosition > sectionTop - halfWindow &&
        scrollPosition < sectionTop + halfWindow
      ) {
        this.removeDotStyles();
        dots[index].classList.add('is-active');
      }
    });
  }

  scrollToSection(e) {
    const dots = Array.from(this.navigation.children);
    const windowHeight = window.innerHeight;

    dots.forEach((dot, index) => {
      if (dot === e.target) {
        window.scrollTo({
          top: windowHeight * index,
          behavior: 'smooth',
        });
      }
    });
  }
}

// Code principal
const sections = document.querySelectorAll('.section');
const dotsContainer = document.querySelector('#js-dots');
const scrollToNext = document.querySelector('#scroll-to-next'); // Sélecteur pour le lien

if (sections.length > 0 && dotsContainer) {
  dotsContainer.addEventListener('click', (e) => {
    const dots = Array.from(dotsContainer.children);
    dots.forEach((dot, index) => {
      if (dot === e.target) {
        window.scrollTo({
          top: window.innerHeight * index,
          behavior: 'smooth',
        });
      }
    });
  });

  if (scrollToNext) {
    scrollToNext.addEventListener('click', (e) => {
      e.preventDefault(); // Empêche le comportement par défaut du lien
      if (sections[1]) {
        // Défiler vers la deuxième section
        window.scrollTo({
          top: sections[1].offsetTop,
          behavior: 'smooth',
        });
      }
    });
  }

  new Slider({
    section: '.section',
    dots: '#js-dots',
  });
}